export const GET_RESPONSIBLE_PERSONS_ON_STOCK = 'GET_RESPONSIBLE_PERSONS_ON_STOCK';
export const GET_RESPONSIBLE_PERSONS_ON_STOCK_SUCCESS = 'GET_RESPONSIBLE_PERSONS_ON_STOCK_SUCCESS';
export const GET_RESPONSIBLE_PERSONS_ON_STOCK_FAIL = 'GET_RESPONSIBLE_PERSONS_ON_STOCK_FAIL';

export const ADD_RESPONSIBLE_PERSON_ON_STOCK = 'ADD_RESPONSIBLE_PERSON_ON_STOCK';
export const ADD_RESPONSIBLE_PERSON_ON_STOCK_SUCCESS = 'ADD_RESPONSIBLE_PERSON_ON_STOCK_SUCCESS';
export const ADD_RESPONSIBLE_PERSON_ON_STOCK_FAIL = 'ADD_RESPONSIBLE_PERSON_ON_STOCK_FAIL';

export const MODAL_RESPONSIBLE_PERSONS_ON_STOCK_OPEN = 'MODAL_RESPONSIBLE_PERSONS_ON_STOCK_OPEN';
export const MODAL_RESPONSIBLE_PERSONS_ON_STOCK_CLOSE = 'MODAL_RESPONSIBLE_PERSONS_ON_STOCK_CLOSE';

export const MODAL_EDIT_RESPONSIBLE_PERSONS_ON_STOCK_OPEN = 'MODAL_EDIT_RESPONSIBLE_PERSONS_ON_STOCK_OPEN';
export const MODAL_EDIT_RESPONSIBLE_PERSONS_ON_STOCK_CLOSE = 'MODAL_EDIT_RESPONSIBLE_PERSONS_ON_STOCK_CLOSE';

export const DEL_RESPONSIBLE_PERSON_ON_STOCK = 'DEL_RESPONSIBLE_PERSON_ON_STOCK';
export const DEL_RESPONSIBLE_PERSON_ON_STOCK_SUCCESS = 'DEL_RESPONSIBLE_PERSON_ON_STOCK_SUCCESS';
export const DEL_RESPONSIBLE_PERSON_ON_STOCK_FAIL = 'DEL_RESPONSIBLE_PERSON_ON_STOCK_FAIL';

export const GET_LIST_RESPONSIBLE_PERSONS = 'GET_LIST_RESPONSIBLE_PERSONS';
export const GET_LIST_RESPONSIBLE_PERSONS_SUCCESS = 'GET_LIST_RESPONSIBLE_PERSONS_SUCCESS';
export const GET_LIST_RESPONSIBLE_PERSONS_FAIL = 'GET_LIST_RESPONSIBLE_PERSONS_FAIL';

export const ADD_RESPONSIBLE_PERSON = 'ADD_RESPONSIBLE_PERSON';
export const ADD_RESPONSIBLE_PERSON_SUCCESS = 'ADD_RESPONSIBLE_PERSON_SUCCESS';
export const ADD_RESPONSIBLE_PERSON_FAIL = 'ADD_RESPONSIBLE_PERSON_FAIL';

export const DEL_RESPONSIBLE_PERSON = 'DEL_RESPONSIBLE_PERSON';
export const DEL_RESPONSIBLE_PERSON_SUCCESS = 'DEL_RESPONSIBLE_PERSON_SUCCESS';
export const DEL_RESPONSIBLE_PERSON_FAIL = 'DEL_RESPONSIBLE_PERSON_FAIL';
